
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Users } from 'lucide-react';
import { InviteUserDialog } from '../InviteUserDialog';

interface EmptyStateProps {
  searchTerm: string;
}

export const EmptyState = ({ searchTerm }: EmptyStateProps) => {
  return (
    <Card>
      <CardContent className="py-8 text-center">
        <Users className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold mb-2">No Members Found</h3>
        <p className="text-muted-foreground mb-4">
          {searchTerm ? 'No members match your search criteria.' : 'No members have been added yet.'}
        </p>
        <InviteUserDialog />
      </CardContent>
    </Card>
  );
};
